var _defs, _rect, _rect2, _rect3, _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgController({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 3 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .line{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n      .tone{fill:var(--icon-accent,#FF8A00);opacity:.14;}\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "tone",
    x: 5.25,
    y: 9,
    width: 4,
    height: 8,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "tone",
    x: 14.75,
    y: 9,
    width: 4,
    height: 8,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "line",
    x: 4,
    y: 8,
    width: 16,
    height: 10,
    rx: 3,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M12 8V5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M10.5 5h3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "line",
    cx: 9,
    cy: 13,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "line",
    cx: 15,
    cy: 13,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "line",
    cx: 12,
    cy: 11,
    r: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgController);
export default __webpack_public_path__ + "static/media/controller.a5db0070f35f88ff4673ef8ba7ef552d.svg";
export { ForwardRef as ReactComponent };